import type { ModuleDefinition } from "../types";
import { TEE_MANAGE, TEE_READ } from "./permissions";

const screens = () => import("./screens");
const course = () => import("./course/screens");

export const teesheetModule: ModuleDefinition = {
  id: "teesheet",
  labelKey: "module.teesheet",
  nav: [
    { id: "sheet", labelKey: "teesheet.nav.sheet", to: "/teesheet", icon: "calendar", permission: TEE_READ, end: true },
    { id: "courses", labelKey: "teesheet.nav.courses", to: "/teesheet/courses", icon: "flag", permission: TEE_MANAGE },
    { id: "templates", labelKey: "teesheet.nav.templates", to: "/teesheet/templates", icon: "clock", permission: TEE_MANAGE },
    { id: "club-course", labelKey: "clubcourse.nav.overview", to: "/club-course", icon: "building", permission: TEE_READ },
    { id: "rules", labelKey: "teesheet.nav.rules", to: "/teesheet/rules", icon: "sliders", permission: TEE_MANAGE },
  ],
  routes: [
    { path: "teesheet", permission: TEE_READ, load: async () => ({ default: (await screens()).SheetPage }) },
    { path: "teesheet/courses", permission: TEE_MANAGE, load: async () => ({ default: (await screens()).CoursesPage }) },
    { path: "teesheet/templates", permission: TEE_MANAGE, load: async () => ({ default: (await screens()).TemplatesPage }) },
    { path: "teesheet/rules", permission: TEE_MANAGE, load: async () => ({ default: (await screens()).RulesPage }) },
    { path: "club-course", permission: TEE_READ, load: async () => ({ default: (await course()).ClubOverviewPage }) },
    { path: "club-course/courses/:courseId", permission: TEE_READ, load: async () => ({ default: (await course()).CoursePage }) },
    { path: "club-course/courses/:courseId/holes/:number", permission: TEE_READ, load: async () => ({ default: (await course()).HolePage }) },
  ],
};
